import { render, staticRenderFns } from "./BoxImage.vue?vue&type=template&id=899a14ec&scoped=true&"
import script from "./BoxImage.vue?vue&type=script&lang=js&"
export * from "./BoxImage.vue?vue&type=script&lang=js&"
import style0 from "./BoxImage.vue?vue&type=style&index=0&id=899a14ec&scoped=true&lang=css&"
import style1 from "./BoxImage.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "899a14ec",
  null
  
)

export default component.exports